import Image from "./Image";
import moment from "moment";

export const statusColor = (status) => {
  if (status) {
    return "active-btn";
  } else {
    return "inactive-btn";
  }
};

export const changeDateFormat = (date) => moment(date).format("DD-MM-YYYY");

export const changeMonthFormat = (date) => moment(date).format("MM");
export const changeYearFormat = (date) => moment(date).format("YYYY");


export const singaporeTime = (val, format = 'DD-MM-YYYY HH:mm:ss') => {
  if (val) {
    const utcTime = moment.utc(val, format);
    const singaporeTime = utcTime.clone().utcOffset('+08:00');
    const formattedTime = singaporeTime.format('DD-MM-YYYY HH:mm:ss');
    return formattedTime;
  }
}

export const singaporeTimeOnly = (val) => {
  if (val) {
    const utcTime = moment.utc(val, 'DD-MM-YYYY HH:mm:ss');
    const singaporeTime = utcTime.clone().utcOffset('+08:00');
    const formattedTime = singaporeTime.format('HH:mm:ss');
    return formattedTime;
  }
}

export const singaporeTimeWithoutSeconds = (val, format = 'DD-MM-YYYY HH:mm:ss') => {
  if (val) {
    const utcTime = moment.utc(val, format);
    const singaporeTime = utcTime.clone().utcOffset('+08:00');
    const formattedTime = singaporeTime.format('DD-MM-YYYY HH:mm');
    return formattedTime;
  }
}

export const isSameDate = (startDate, endDate) => {
  return moment(startDate, 'DD-MM-YYYY HH:mm:ss').isSame(moment(endDate, 'DD-MM-YYYY HH:mm:ss'), 'day');
}

export const getDateOnly = (date) => {
  return moment(date, "DD-MM-YYYY HH:mm:ss").format("DD-MM-YYYY");
}

export const removeSecondsFromColonSeperatedString = (value) => {
  if (!value) return "";
  const parts = String(value).split(":");
  if (parts.length < 2) return value;
  return `${parts[0]}:${parts[1]}`;
}

export const eventColor = (event) => {
  if (event) {
    return "event-start";
  } else {
    return "event-stop";
  }
};

export const iconColor = (event) => {
  if (event === Number(0)) {
    return <Image name="gray.gif" />;
  } if (event <= Number(3)) {
    return <Image name="yellow.gif" />;
  } else if (event <= Number(5)) {
    return <Image name="green.gif" />;
  } else if (event <= Number(7)) {
    return <Image name="red.gif" />
  } else if (event > Number(7)) {
    return <Image name="blue.gif" />;
  }
};


export const iconCount = (event) => {

  if (event === Number(0)) {
    return "count-gray";
  } else if (event <= Number(3)) {
    return "count-yellow";
  } else if (event <= Number(5)) {
    return "count-green";
  } else if (event <= Number(7)) {
    return "count-red";
  } else if (event > Number(7)) {
    return "count-blue";
  }
};

export const exportToJson = (dataCsv, fileName) => {
  downloadFile({
    data: dataCsv,
    fileName: fileName,
    fileType: 'text/csv',
  })
}

export const downloadFile = ({ data, fileName, fileType }) => {
  const blob = new Blob([data], { type: fileType })
  const a = document.createElement('a')
  a.download = fileName
  a.href = window.URL.createObjectURL(blob)
  const clickEvt = new MouseEvent('click', {
    view: window,
    bubbles: true,
    cancelable: true,
  })
  a.dispatchEvent(clickEvt)
  a.remove()
}

//image type for aws service
export const profile_image_type = 1;
export const floor_image_type = 2;
export const admin_image_type = 3;

//report types for employee
export const attendance_type = 1;
export const absentee_type = 2;

//reason types for unauthorised employee
export const all_reason = 0;
export const unauthorised_entry = 1;
export const not_in_zone_at_working_hours = 2;
export const working_beyond_work_permit_hours = 3;

export const calculateEightHoursAgo = (givenTime) => {
  if (givenTime) {
    const dateParts = givenTime.split(/[- :]/);
    const givenDate = new Date(dateParts[2], dateParts[1] - 1, dateParts[0], dateParts[3], dateParts[4], dateParts[5]);
    const currentDate = getSingaporeTime();
    const differenceInSeconds = Math.floor((currentDate - givenDate) / 1000);
    if (differenceInSeconds < 28800) { // 8 hours = 28800 seconds
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
};

export const getSingaporeTime = () => {
  const currentTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  if (currentTimeZone === "Asia/Singapore") {
    return new Date();
  }

  const now = new Date();
  const formatter = new Intl.DateTimeFormat("en-US", {
    timeZone: "Asia/Singapore",
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
  });

  const parts = formatter.formatToParts(now);
  const year = parseInt(parts.find(p => p.type === 'year').value);
  const month = parseInt(parts.find(p => p.type === 'month').value);
  const day = parseInt(parts.find(p => p.type === 'day').value);
  const hours = parseInt(parts.find(p => p.type === 'hour').value);
  const minutes = parseInt(parts.find(p => p.type === 'minute').value);
  const seconds = parseInt(parts.find(p => p.type === 'second').value);

  return new Date(year, month - 1, day, hours, minutes, seconds);
};

export const calculateTimeAgo = (givenTime) => {
  if (givenTime) {
    // const givenTime = "19-02-2024 09:14:07";
    const dateParts = givenTime.split(/[- :]/);
    const givenDate = new Date(dateParts[2], dateParts[1] - 1, dateParts[0], dateParts[3], dateParts[4], dateParts[5]);

    // const givenDate = new Date(givenTime);
    const currentDate = getSingaporeTime();
    const differenceInSeconds = Math.floor((currentDate - givenDate) / 1000);

    let interval = Math.floor(differenceInSeconds / 31536000);
    if (interval >= 1) {
      return `${interval} year${interval === 1 ? '' : 's'} ago`;
    }
    interval = Math.floor(differenceInSeconds / 2592000);
    if (interval >= 1) {
      return `${interval} month${interval === 1 ? '' : 's'} ago`;
    }
    interval = Math.floor(differenceInSeconds / 86400);
    if (interval >= 1) {
      return `${interval} day${interval === 1 ? '' : 's'} ago`;
    }
    interval = Math.floor(differenceInSeconds / 3600);
    if (interval >= 1) {
      return `${interval} hour${interval === 1 ? '' : 's'} ago`;
    }
    interval = Math.floor(differenceInSeconds / 60);
    if (interval >= 1) {
      return `${interval} minute${interval === 1 ? '' : 's'} ago`;
    }
    return `${differenceInSeconds} second${differenceInSeconds === 1 ? '' : 's'} ago`;
  }
};